/**
 * Exhaustiveness guard for discriminated-union switches.
 *
 * Placing `default: return assertNever(x)` at the end of a `switch` over a
 * union's discriminant makes the compiler fail if a new variant is added but
 * not handled: the un-handled variant is no longer narrowed to `never`, so the
 * argument stops type-checking. Also throws at runtime as a defensive backstop.
 */
export function assertNever(value: never): never {
  throw new Error(`Unexpected value: ${JSON.stringify(value)}`);
}
